/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerCustomerDemoListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CustomerCustomerDemoService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';

import myGlobals = require('../globals');
import { CustomerCustomerDemoData, CustomerCustomerDemoService } from './CustomerCustomerDemo.service';
import { CustomerCustomerDemoSearchComponent }  from './CustomerCustomerDemoSearch.component';

@Component({
	selector: 'my-CustomerCustomerDemo',
	template: require('./CustomerCustomerDemoList.component.html'),
	providers: [CustomerCustomerDemoService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomerCustomerDemoListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	CustomerCustomerDemoList: CustomerCustomerDemoData[];
	newCustomerCustomerDemo: CustomerCustomerDemoData;
	selectedCustomerCustomerDemo: CustomerCustomerDemoData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(CustomerCustomerDemoSearchComponent) filterComponent: CustomerCustomerDemoSearchComponent;

	sortExpression: string = "CustomerID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private CustomerCustomerDemoService: CustomerCustomerDemoService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newCustomerCustomerDemo = new CustomerCustomerDemoData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		//this.CustomerCustomerDemoService.getAll().subscribe(record => this.CustomerCustomerDemoList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getCustomerCustomerDemoByPaging();

		/*
		this.CustomerCustomerDemoList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getCustomerCustomerDemo() {
		this.CustomerCustomerDemoService.getAll()
			.subscribe(data => this.CustomerCustomerDemoList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on CustomerCustomerDemoSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getCustomerCustomerDemoByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getCustomerCustomerDemoByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getCustomerCustomerDemoByPaging();
	}
	
	// Get records by paging
	getCustomerCustomerDemoByPaging() {
		this.CustomerCustomerDemoService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.CustomerCustomerDemoList=data.CustomerCustomerDemoList;
				this.rowsCount=data.RowsCount;
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}

	// Adds new record
	addCustomerCustomerDemo() {
		this.CustomerCustomerDemoService.addCustomerCustomerDemoData(this.newCustomerCustomerDemo).subscribe(record => console.log(record));
		this.getCustomerCustomerDemo();
	}

	// Updates existing record
	updateCustomerCustomerDemo() {
		this.CustomerCustomerDemoService.updateCustomerCustomerDemoData(this.selectedCustomerCustomerDemo).subscribe(record => console.log(record));
		this.getCustomerCustomerDemo();
	}

	// Deletes record with specified id
	deleteCustomerCustomerDemo(id: string) {
		if (window.confirm('Are you sure you want to delete this CustomerCustomerDemo?') == true)
		{
			this.CustomerCustomerDemoService.deleteCustomerCustomerDemo(id)
			.subscribe(data => this.getCustomerCustomerDemo(),
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('CustomerCustomerDemo record deleted successfully...', 'Delete CustomerCustomerDemo');
					console.log('CustomerCustomerDemo record deleted successfully...'); 
				}
			);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getCustomerCustomerDemoByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getCustomerCustomerDemoByPaging();
		}
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getCustomerCustomerDemoByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getCustomerCustomerDemoByPaging();
	}

	// On Edit - Go to Edit page
	onSelect(item: CustomerCustomerDemoData) {
		this.router.navigate(['/CustomerCustomerDemo', item.CustomerID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: CustomerCustomerDemoData) {
		this.router.navigate(['/CustomerCustomerDemo/Details', item.CustomerID]);
	}

	// Set record as selected
	SelectCustomerCustomerDemo(item: CustomerCustomerDemoData) {
		this.selectedCustomerCustomerDemo = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerCustomerDemo/CustomerCustomerDemoList.component.ts